
/**
 * To modify immutable objects
 * @param {Object} oldObject - Immutable state
 * @param {Object} updatedProperties - Modified properties
 * @return Modified State
 */
export const updateObject = (oldObject, updatedProperties) => {
     return {
          ...oldObject,
          ...updatedProperties
     };
};


/**
 * To Check whether the Object is Valid or not
 * @param {Object} Object of any type - Immutable state
 * @return boolean true if null or undefined
 */
export const isValid = (object) => {
     return (object !== null && object !== undefined);
}

const SOCIAL_FEDERATION_ORIGINS = ['google', 'apple', 'azure_social'];

/**
 * Social federated users (Google, Apple, Azure social).
 * @param {Object} authProfile - OIDC profile from state.auth.profile
 * @return {boolean}
 */
export const isSocialUser = (authProfile) => {
     const origin = authProfile?.federation_origin ?? null;
     return SOCIAL_FEDERATION_ORIGINS.includes(origin);
};

/**
 * Native Trimble Identity users (password or passkey), excluding social.
 * @param {Object} authProfile - OIDC profile from state.auth.profile
 * @return {boolean}
 */
export const isTIDUser = (authProfile) => {
     const amr = authProfile?.amr ?? [];
     return amr.some((value) => value === 'password' || value === 'passkey') && !isSocialUser(authProfile);
};

/**
 * Enterprise federated users (SSO / IdP). Names and credentials are managed by the organization administrator.
 * @param {Object} authProfile - OIDC profile from state.auth.profile
 * @return {boolean}
 */
export const isEnterpriseFederatedUser = (authProfile) => {
     return !(isTIDUser(authProfile) || isSocialUser(authProfile));
};

/**
 * First/last name are locked for enterprise SSO (token) and for accounts with
 * has_federations from GET /user/{uuid} (pure social, or native with a linked IdP).
 * Enterprise users do not receive has_federations.
 * @param {Object} authProfile - OIDC profile from state.auth.profile
 * @param {Object} identity - Identity API payload from state.userManager.identity
 * @return {boolean}
 */
export const areNameFieldsLocked = (authProfile, identity) =>
     Boolean(identity?.has_federations) || isEnterpriseFederatedUser(authProfile);

/**
 * Native TID session on an account that also has federations (case 3).
 * @param {Object} authProfile - OIDC profile from state.auth.profile
 * @param {Object} identity - Identity API payload from state.userManager.identity
 * @return {boolean}
 */
export const isNativeWithFederations = (authProfile, identity) =>
     Boolean(identity?.has_federations) && isTIDUser(authProfile);